/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllDeviceInSpace } from 'services/api/devicesApi';
import { TDeviceResponseType, TSpaceDevicesState } from 'typings';

export const fetchSpaceDevices = createAsyncThunk(
  'spaces/fetchSpaceDevices',
  async (payload: string, thunkAPI) => {
    try {
      const response = await getAllDeviceInSpace(payload);
      console.log('all devices in space Response', response.data);
      return response.data.items as TDeviceResponseType[];
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialSpaceDevicesState: TSpaceDevicesState = {
  spaceDevices: [],
  isLoading: false
};

export const spaceDevicesSlice = createSlice({
  name: 'spaceDevices',
  initialState: initialSpaceDevicesState,
  reducers: {
    clearSpaceDevices: (state) => {
      state.spaceDevices = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpaceDevices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.spaceDevices = action.payload;
      })
      .addCase(fetchSpaceDevices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSpaceDevices.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearSpaceDevices } = spaceDevicesSlice.actions;

export default spaceDevicesSlice.reducer;
